import {TextField} from '@material-ui/core';
import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import {Dispatch} from 'redux';
import {localized} from '../../../../state/i18n/i18n';
import {showSuccess} from '../../../../state/snackbar/operations';
import {AppState} from '../../../../state/store';

const mapDispatchToProps = (dispatch: Dispatch) => ({
  getSnackbarSuccess: () => showSuccess(localized('YourChangesAreSaved'))(dispatch),
});

const mapStateToProps = (state: AppState) => {
  return {
    successStatus: state.notificationSettingsReducer.success,
  };
};

interface PropsFromParent {
  initialValue?: number;
  onChange: (value: number) => void;
}

interface State {
  value: string;
}

type Props = Partial<ReturnType<typeof mapDispatchToProps>> &
  PropsFromParent &
  Partial<ReturnType<typeof mapStateToProps>>;

class DeviceManagementField extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      value: this.props.initialValue?.toString() || '0',
    };
  }

  componentDidUpdate = (prevProps: Props) => {
    if (prevProps.initialValue !== this.props.initialValue) {
      this.props.initialValue && this.setState({value: this.props.initialValue.toString()});
    }
  };

  private setMeasurement = (event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    this.setState({value: event.target.value});
  };

  private getMeasurement = () => {
    return this.state.value;
  };

  private onChange = (event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    if (event.target.value === '') {
      this.props.onChange(0);
      this.props.getSnackbarSuccess && this.props.getSnackbarSuccess();
    } else this.props.onChange(parseFloat(event.target.value));
    this.props.getSnackbarSuccess && this.props.getSnackbarSuccess();
  };

  public render() {
    return (
      <TextField
        id="outlined-basic"
        variant="outlined"
        type="number"
        value={this.getMeasurement()}
        onChange={this.setMeasurement}
        onBlur={this.onChange}
      />
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DeviceManagementField);
